"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapReportingCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../../i18n/messageLoader");
const SnapReportingCard_module_css_1 = __importDefault(require("./SnapReportingCard.module.css"));
const reportingUtils_1 = require("./utils/reportingUtils");
const web_env_1 = require("@snapchat/web-env");
/**
 * Reporting Card for Story reporting.
 */
function SnapReportingCard({ snapId, storyType, playNext, isMobile, pauseSnap, playSnap, playlistEnded, locale, onReportSubmit: propsOnReportSubmit, showMenuItems, closeMenu, verticalOffset, shepherd, onShepherdReportSubmit, }) {
    const [resolvedLocale] = (0, react_1.useState)((0, web_i18n_1.getLocale)(locale));
    const [messages, setMessages] = (0, react_1.useState)({});
    const [showReportModal, setShowReportModal] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        void (0, messageLoader_1.loadMessages)(resolvedLocale).then((messages) => {
            setMessages(messages);
        });
    }, [resolvedLocale]);
    const onModalClose = (0, react_1.useCallback)(() => {
        closeMenu();
        setShowReportModal(false);
        // only resume playback if story has not ended
        if (!playlistEnded) {
            playSnap();
        }
    }, [playSnap, playlistEnded, setShowReportModal, closeMenu]);
    // close reporting whenever snapId changes
    (0, react_1.useEffect)(() => {
        if (showReportModal) {
            onModalClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [snapId, onModalClose]);
    const removePageClickListener = () => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        (0, web_env_1.getDocument)()?.removeEventListener("click", handlePageClick, false);
    };
    const handlePageClick = (0, react_1.useCallback)(() => {
        closeMenu();
        removePageClickListener();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeMenu]);
    // hides menu items when user clicks outside the container
    (0, react_1.useEffect)(() => {
        if (showMenuItems) {
            (0, web_env_1.getDocument)()?.addEventListener("click", handlePageClick, false);
        }
        // remove listener before page is removed from DOM
        return () => removePageClickListener();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showMenuItems]);
    // expected url: <url><endpoint>?storyId=<storyId>&reasonId=<reasonId>&...&storyType=<storyType>
    const onReportSubmit = (0, react_1.useCallback)((reportSubmission) => {
        const fieldsToSubmit = {
            storyId: snapId,
            reasonId: reportSubmission.id,
            context: reportSubmission.reportDescription || "",
            source: (0, reportingUtils_1.determineReportingSourceField)(storyType),
            storyType: storyType,
        };
        (0, reportingUtils_1.submitReportingFields)(fieldsToSubmit).catch((e) => {
            if (process.env.NODE_ENV !== "production") {
                console.error(e);
            }
        });
        propsOnReportSubmit?.(snapId);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [snapId, propsOnReportSubmit]);
    const handleReportMenuItemClick = (0, react_1.useCallback)(() => {
        setShowReportModal(true);
        pauseSnap();
    }, [pauseSnap]);
    const renderReportModal = () => ((0, jsx_runtime_1.jsx)(web_core_ui_1.ReportModal, { locale: locale, onSubmit: onReportSubmit, isVisible: showReportModal, onModalClose: onModalClose, isMobile: isMobile, playNext: playNext }));
    const renderShepherdReportModal = () => ((0, jsx_runtime_1.jsx)("div", { className: SnapReportingCard_module_css_1.default.container, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.ShepherdReportModal, { locale: locale, onSubmit: (report) => onShepherdReportSubmit?.(report), isVisible: showReportModal, onModalClose: onModalClose, isMobile: isMobile }) }));
    const offsetStyle = verticalOffset ? { translate: `0 -${verticalOffset}px` } : {};
    const renderMenuItems = () => ((0, jsx_runtime_1.jsx)("span", { className: (0, clsx_1.default)(SnapReportingCard_module_css_1.default.menuItemsContainer, SnapReportingCard_module_css_1.default.baseElements), style: offsetStyle, children: (0, jsx_runtime_1.jsxs)(web_core_ui_1.MenuItemButton, { onClick: handleReportMenuItemClick, children: [(0, jsx_runtime_1.jsx)("div", { className: SnapReportingCard_module_css_1.default.iconWrapper, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.ErrorIcon, { size: "MEDIUM" }) }), (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", children: (0, jsx_runtime_1.jsx)("span", { className: SnapReportingCard_module_css_1.default.textColor, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "JKXckK", description: "The report snap label on the menu list of the Story web player", defaultMessage: "Report Snap" }) }) })] }) }));
    return ((0, jsx_runtime_1.jsxs)(react_intl_1.IntlProvider, { locale: resolvedLocale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: [showMenuItems && renderMenuItems(), showReportModal && !shepherd && renderReportModal(), showReportModal && shepherd && renderShepherdReportModal()] }));
}
exports.SnapReportingCard = SnapReportingCard;
//# sourceMappingURL=SnapReportingCard.js.map